import { useCallback, useMemo } from 'react';
import { useAuthStore } from 'stores/auth-store';

const DEFAULT_LICENSE_PLATE_REGEX =
  /^([A-Z]{2}[0-9]{1,2}[A-Z]{1,3}[0-9]{4}|[0-9]{2}BH[0-9]{4}[A-Z]{1,2})$/;

export function useLicensePlateNumberValidator() {
  const licensePlatePattern = useAuthStore(
    (state) => state.workshopCustomer?.license_plate_number_regex,
  );

  const licensePlateRegex = useMemo(() => {
    if (!licensePlatePattern?.trim()) {
      return DEFAULT_LICENSE_PLATE_REGEX;
    }

    try {
      return new RegExp(licensePlatePattern);
    } catch (error) {
      console.warn(
        'Invalid license plate regex pattern from config, using default:',
        error,
      );
      return DEFAULT_LICENSE_PLATE_REGEX;
    }
  }, [licensePlatePattern]);

  return useCallback(
    (value) => {
      const cleanedInput = value
        .trim()
        .toUpperCase()
        .replace(/[\s-]+/g, '');

      return cleanedInput === '' || licensePlateRegex.test(cleanedInput);
    },
    [licensePlateRegex],
  );
}
